import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";

export function PageShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle }: { eyebrow: string; title: string; subtitle?: string }) {
  return (
    <section className="relative overflow-hidden border-b border-border/40 bg-card pt-40 pb-20">
      <div className="absolute inset-0 opacity-30 [background-image:radial-gradient(circle_at_30%_20%,oklch(0.6_0.15_240/0.4),transparent_50%),radial-gradient(circle_at_80%_80%,oklch(0.85_0.12_85/0.2),transparent_50%)]" />
      <div className="relative mx-auto max-w-5xl px-6 text-center">
        <p className="text-xs tracking-[0.4em] text-primary">{eyebrow}</p>
        <h1 className="mt-6 font-serif text-5xl md:text-6xl">{title}</h1>
        {subtitle && <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground">{subtitle}</p>}
      </div>
    </section>
  );
}